import React, { useState, useEffect } from 'react';
import { Icon, Button } from 'porosys-ui';
import UserForm from '../form/UserForm';
import UserSyncModal from '../sync/UserSyncModal';
import ListHeader from '../../../common/ui/components/ListHeader/ListHeader';
import handleSeprateArrayContents from '../../../common/utils/print-array-contents';
import { getUsers, deleteUser, getUsersAcl } from '../api';
import DeleteConfirmation from '../../../common/ui/components/DeleteConfirmation/DeleteConfirmation';
import Pagination from '../../../common/ui/components/Pagination/Pagination';
import '../styles.scss';

const UserList = props => {
    const [users, setUsers] = useState([]);
    const [usersCount, setUsersCount] = useState(0);
    const [shouldShowForm, setShouldShowForm] = useState(false);
    const [userToEdit, setUserToEdit] = useState();
    const [usersAcl, setUsersAcl] = useState({});
    const [isDeleteConfirmationShowing, setIsDeleteConfirmationShowing] = useState(false);
    const [userIdToDelete, setUserIdToDelete] = useState(null);
    const [isSyncModalOpen, setIsSyncModalOpen] = useState(false);

    useEffect(() => {
        handlePageChange(1);
        const fetchUsersAcl = async () => {
            setUsersAcl(await getUsersAcl());
        };

        fetchUsersAcl();
    }, []);

    const handlePageChange = pageNumber => {
        const fetchUsers = async () => {
            const data = await getUsers(pageNumber);
            setUsersCount(data.count);
            setUsers(data.users);
        };
        fetchUsers();
    };

    const refreshUsers = () => {
        handlePageChange(1);
    };
    const handleToggleForm = () => {
        setShouldShowForm(!shouldShowForm);
    };
    const handleAddUser = user => {
        setShouldShowForm(false);
        setUsers(users => [user, ...users]);
    };
    const handleUpdateUser = updatedAction => {
        setShouldShowForm(false);
        const indexOfUpdatedUser = users.findIndex(action => action._id === updatedAction._id);
        const updatedUsers = [...users];
        updatedUsers[indexOfUpdatedUser] = updatedAction;
        setUsers(updatedUsers);
        setUserToEdit(null);
    };
    const handleEditUser = action => {
        setUserToEdit(action);
        setShouldShowForm(true);
    };
    const handleDeleteUser = async () => {
        if (!userIdToDelete) return;
        await deleteUser(userIdToDelete);
        const remainingUsers = users.filter(action => {
            return action._id !== userIdToDelete;
        });

        setUsers(remainingUsers);
        setIsDeleteConfirmationShowing(false);
    };
    return (
        <div className="list users-list">
            <div className="content">
                {shouldShowForm ? (
                    <UserForm
                        userToEdit={userToEdit}
                        handleCancel={() => {
                            handleToggleForm();
                            setUserToEdit(null);
                        }}
                        handleAddUser={handleAddUser}
                        handleUpdateUser={handleUpdateUser}
                    />
                ) : (
                    <>
                        <ListHeader listTitle="کاربران" handleOpenForm={handleToggleForm} />

                        {usersAcl.view && (
                            <div className="users-sync-btn">
                                <Button color="primary" onClick={() => setIsSyncModalOpen(true)}>
                                    همگام‌سازی با پروسیس
                                </Button>
                            </div>
                        )}

                        <table className="users-table">
                            <thead>
                                <tr>
                                    <th>نام و نام خانوادگی</th>
                                    <th>واحد فعالیت</th>
                                    <th>نقش</th>
                                    <th>ایمیل</th>
                                    <th>#</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users && users.length > 0 ? (
                                    users.map(user => (
                                        <tr id="tr" key={user._id} className="card-layout">
                                            <td>{user.fullname}</td>
                                            <td>
                                                {user.departments &&
                                                    handleSeprateArrayContents('label', user.departments)}
                                            </td>
                                            <td>{user.role}</td>
                                            <td>{user.email}</td>
                                            <td>
                                                <div className="actions-btn">
                                                    {usersAcl.delete && (
                                                        <button
                                                            className="btn delete-button"
                                                            onClick={() => {
                                                                setIsDeleteConfirmationShowing(true);
                                                                setUserIdToDelete(user._id);
                                                            }}
                                                        >
                                                            <Icon fontSize={1} name="trash" />
                                                        </button>
                                                    )}
                                                    {usersAcl.edit && (
                                                        <button className="btn" onClick={() => handleEditUser(user)}>
                                                            <Icon fontSize={1} name="pen" />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr id="tr" className="card-layout">
                                        <td colSpan={5}>اطلاعاتی وجود ندارد</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination count={usersCount} onChange={(e, pageNumber) => handlePageChange(pageNumber)} />
                        <DeleteConfirmation
                            onClose={() => {
                                setIsDeleteConfirmationShowing(false);
                            }}
                            onClickOk={() => {
                                handleDeleteUser();
                            }}
                            isOpen={isDeleteConfirmationShowing}
                        />
                        <UserSyncModal
                            isOpen={isSyncModalOpen}
                            onClose={() => setIsSyncModalOpen(false)}
                            onSyncComplete={refreshUsers}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default UserList;
